// utils/cloudinaryUpload.ts
export const uploadPhoto = async (file: File, subfolder: string): Promise<string | null> => {
    const formData = new FormData();
    const folderPath = `TownOf1000Trails/${subfolder}`; // Subfolder path

    formData.append('file', file);
    formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET ?? '');
    formData.append('folder', folderPath);

    try {
        const res = await fetch(
            `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_NAME}/image/upload`,
            {
                method: 'POST',
                mode: 'cors',
                body: formData,
            }
        );

        const json = await res.json();

        if (res.ok) {
            console.log("Image uploaded successfully:", json.secure_url);
            return json.secure_url; // Return the secure URL of the uploaded image
        } else {
            console.error("Failed to upload image:", json.error.message);
            return null;
        }
    } catch (error) {
        console.error("Error uploading image:", error);
        return null;
    }
};

export const batchUploadToCloudinary = async (files: File[], subfolder: string) => {
    try {
        console.log('batchUploadToCloudinary :::', files, subfolder);
        return await Promise.all(files.map(file => uploadPhoto(file, subfolder)));
    } catch (error) {
        console.error("Error uploading images:", error);
        return [];
    }
};

export const getCloudinaryFeaturedImageUrl = (publicId: string) => {
    return `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_NAME}/${process.env.REACT_APP_CLOUDNARY_FEATURED_IMAGE_SUBFLODER}/${publicId}`;
};

export const getCloudinaryOtherImageUrl = (publicId: string) => {
    return `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_NAME}/${process.env.REACT_APP_CLOUDNARY_OTHER_IMAGES_SUBFLODER}/${publicId}`;
};

export const base64ToFile = async (base64Data: string, fileName: string): Promise<File> => {
    const response = await fetch(base64Data);
    const blob = await response.blob();
    return new File([blob], fileName, { type: blob.type });
  };

export const cleanFileName = (fileName: string | undefined | null): string => {
    if (!fileName) {
      return '';
    }
    
    return fileName
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-zA-Z0-9-_.]/g, '')
      .toLowerCase();
  };

  // Add this new function to src/util/cloudinaryUpload.ts

  export const uploadGpxFile = async (file: File): Promise<string | null> => {
    const formData = new FormData();
    const folderPath = 'TownOf1000Trails/gpx_files';

    // Clean the file name before uploading
    const cleanedFileName = cleanFileName(file.name);
    const renamedFile = new File([file], cleanedFileName, { type: file.type });

    formData.append('file', renamedFile);
    formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET ?? '');
    formData.append('folder', folderPath);
    formData.append('resource_type', 'raw');

    try {
        const res = await fetch(
            `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_NAME}/raw/upload`,
            {
                method: 'POST',
                mode: 'cors',
                body: formData,
            }
        );

        const json = await res.json();

        if (res.ok) {
            console.log("GPX file uploaded successfully:", json.secure_url);
            return json.secure_url;
        } else {
            console.error("Failed to upload GPX file:", json.error.message);
            return null;
        }
    } catch (error) {
        console.error("Error uploading GPX file:", error);
        return null;
    }
};